<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            ¿Estas seguro de eliminar el registro?
          </h4>
        </template>
        <div class="con-form">
                <p>Nombre: <strong>{{info.nombre}}</strong></p>
                <p v-if="info.tipo_escala !== '' && info.tipo_escala !== null">Tipo de escala: <strong>{{info.tipo_escala}}</strong></p>
                <p v-if="info.valor_minimo !== '' && info.valor_minimo !== null">Valor mínimo: <strong>{{info.valor_minimo}}</strong></p>
                <p v-if="info.valor_maximo !== '' && info.valor_maximo !== null">Valor máximo: <strong>{{info.valor_maximo}}</strong></p>
                <p v-if="info.valor_acreditable !== '' && info.valor_acreditable !== null">Valor acreditable: <strong>{{info.valor_acreditable}}</strong></p>
                <p v-if="info.tipo_numerico !== '' && info.tipo_numerico !== null"><strong>{{info.tipo_numerico}}</strong></p>
                <p v-if="info.decimales !== '' && info.decimales !== null">Decimales: <strong>{{info.decimales}}</strong></p>
                <p v-if="valores_alfanumericos_acreditables !== '' && info.valores_alfanumericos_acreditables !== null">Valores alfanuméricos: <strong>{{valores_alfanumericos_acreditables}}</strong></p>
                <p v-if="valores_alfanumericos !== '' && valores_alfanumericos !== null">Valores alfanuméricos acreditables: <strong>{{valores_alfanumericos}}</strong></p>
                <p v-show="info.descripcion !== '' && info.descripcion !== null">Descripción: <strong>{{info.descripcion}}</strong></p>
        </div>

        <template #footer>
          <div class="footer-dialog d-flex">
            <vs-button danger block @click="active = false" style="width: 30%;">
              Cancelar
            </vs-button>
            <vs-button success class="ml-auto" block @click="getEliminar()" style="width: 30%;">
              Aceptar
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'info',
    ],
    data(){
        return{
            active: false,
            valores_alfanumericos: '',
            valores_alfanumericos_acreditables: ''
        }
    },
    methods:{
        async getEliminar(){
            try{
                const { data: response } = await academico.getEliminar(this.info.id)
                this.$vs.notification({
                    progress: 'auto',                           
                    color: 'success',
                    position: null,
                    title: 'El registro se ha eliminado'
                })
                this.active = false
                this.$emit('refreshTable')
            }catch{

            }
        }
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      info(){
          if(this.info.tipo_escala === 'alfanumerica'){
            this.valores_alfanumericos_acreditables = this.info.valores_alfanumericos_acreditables.join()
            this.valores_alfanumericos = this.info.valores_alfanumericos.join()
          }
      }
    }
}
</script>
